module.exports = new __parcel__URL__("meteo_select.7431bb88.svg").toString();